import http from './http';

const getThreads = (value, page) => {
  const q = value && value.length > 0 ? `&query=${encodeURIComponent(value)}` : '';
  return http.get(`/thread?page_size=10&page_nbr=${page}&sort_field=created_at&sort_type=desc&empty=true${q}`);
};

export default { getThreads };
export { getThreads };
